import { render, staticRenderFns } from "./PurchaseEditDefault.vue?vue&type=template&id=0b8c0ace&scoped=true"
import script from "./PurchaseEditDefault.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditDefault.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEditDefault.vue?vue&type=style&index=0&id=0b8c0ace&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c0ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8c0ace')) {
      api.createRecord('0b8c0ace', component.options)
    } else {
      api.reload('0b8c0ace', component.options)
    }
    module.hot.accept("./PurchaseEditDefault.vue?vue&type=template&id=0b8c0ace&scoped=true", function () {
      api.rerender('0b8c0ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditDefault.vue"
export default component.exports